define.alias("shared/components/shared/mavely/links/folders-tab", "settings/components/shared/mavely/links/folders-tab");